import _toConsumableArray from "D:\\GitHub\\horizon-curve-visualizer\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "D:\\GitHub\\horizon-curve-visualizer\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\GitHub\\horizon-curve-visualizer\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\GitHub\\horizon-curve-visualizer\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\GitHub\\horizon-curve-visualizer\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _get from "D:\\GitHub\\horizon-curve-visualizer\\node_modules\\@babel\\runtime/helpers/esm/get";
import _inherits from "D:\\GitHub\\horizon-curve-visualizer\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "D:\\GitHub\\horizon-curve-visualizer\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _slicedToArray from "D:\\GitHub\\horizon-curve-visualizer\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useState, memo, useMemo, useEffect, Component } from 'react';
import { observe, unobserve, isObservable, raw, observable } from '@nx-js/observer-util';
import { unstable_batchedUpdates } from './react-platform'; // it is window in the DOM and global in NodeJS and React Native

var isDOM = typeof window !== 'undefined';
var isNative = typeof global !== 'undefined';
var globalObj = isDOM ? window : isNative ? global : undefined;
var hasHooks = typeof useState === 'function';
var isInsideFunctionComponent = false;
var COMPONENT = Symbol('owner component');

function view(Comp) {
  var isStatelessComp = !(Comp.prototype && Comp.prototype.isReactComponent);
  var ReactiveComp;

  if (isStatelessComp && hasHooks) {
    // use a hook based reactive wrapper when we can
    ReactiveComp = memo(function (props) {
      // use a dummy setState to update the component
      var _useState = useState(),
          _useState2 = _slicedToArray(_useState, 2),
          setState = _useState2[1]; // create a memoized reactive wrapper of the original component (render)
      // at the very first run of the component function


      var render = useMemo(function () {
        return observe(Comp, {
          scheduler: function scheduler() {
            return setState({});
          },
          lazy: true
        });
      }, []); // cleanup the reactive connections after the very last render of the component

      useEffect(function () {
        return function () {
          return unobserve(render);
        };
      }, []); // the isInsideFunctionComponent flag is used to toggle `store` behavior
      // based on where it was called from

      isInsideFunctionComponent = true;

      try {
        // run the reactive render instead of the original one
        return render(props);
      } finally {
        isInsideFunctionComponent = false;
      }
    });
  } else {
    var BaseComp = isStatelessComp ? Component : Comp; // a HOC which overwrites render, shouldComponentUpdate and componentWillUnmount
    // it decides when to run the new reactive methods and when to proxy to the original methods

    var ReactiveClassComp =
    /*#__PURE__*/
    function (_BaseComp) {
      _inherits(ReactiveClassComp, _BaseComp);

      function ReactiveClassComp(props, context) {
        var _this;

        _classCallCheck(this, ReactiveClassComp);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactiveClassComp).call(this, props, context));
        _this.state = _this.state || {};
        _this.state[COMPONENT] = _assertThisInitialized(_assertThisInitialized(_this)); // create a reactive render for the component

        _this.render = observe(_this.render, {
          scheduler: function scheduler() {
            return _this.setState({});
          },
          lazy: true
        });
        return _this;
      }

      _createClass(ReactiveClassComp, [{
        key: "render",
        value: function render() {
          return isStatelessComp ? Comp(this.props, this.context) : _get(_getPrototypeOf(ReactiveClassComp.prototype), "render", this).call(this);
        } // react should trigger updates on prop changes, while easyState handles store changes

      }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
          var props = this.props,
              state = this.state; // respect the case when the user defines a shouldComponentUpdate

          if (_get(_getPrototypeOf(ReactiveClassComp.prototype), "shouldComponentUpdate", this)) {
            return _get(_getPrototypeOf(ReactiveClassComp.prototype), "shouldComponentUpdate", this).call(this, nextProps, nextState);
          } // return true if it is a reactive render or state changes


          if (state !== nextState) {
            return true;
          } // the component should update if any of its props shallowly changed value


          var keys = Object.keys(props);
          var nextKeys = Object.keys(nextProps);
          return nextKeys.length !== keys.length || nextKeys.some(function (key) {
            return props[key] !== nextProps[key];
          });
        } // add a custom deriveStoresFromProps lifecyle method

      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          // call user defined componentWillUnmount
          if (_get(_getPrototypeOf(ReactiveClassComp.prototype), "componentWillUnmount", this)) {
            _get(_getPrototypeOf(ReactiveClassComp.prototype), "componentWillUnmount", this).call(this);
          } // clean up memory used by Easy State


          unobserve(this.render);
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(props, state) {
          if (_get(_getPrototypeOf(ReactiveClassComp), "deriveStoresFromProps", this)) {
            var _get2;

            // inject all local stores and let the user mutate them directly
            var stores = mapStateToStores(state);

            (_get2 = _get(_getPrototypeOf(ReactiveClassComp), "deriveStoresFromProps", this)).call.apply(_get2, [this, props].concat(_toConsumableArray(stores)));
          } // respect user defined getDerivedStateFromProps


          if (_get(_getPrototypeOf(ReactiveClassComp), "getDerivedStateFromProps", this)) {
            return _get(_getPrototypeOf(ReactiveClassComp), "getDerivedStateFromProps", this).call(this, props, state);
          }

          return null;
        }
      }]);

      return ReactiveClassComp;
    }(BaseComp);

    ReactiveComp = ReactiveClassComp;
  }

  ReactiveComp.displayName = Comp.displayName || Comp.name; // static props are inherited by class components,
  // but have to be copied for function components

  if (isStatelessComp) {
    var _arr = Object.keys(Comp);

    for (var _i = 0; _i < _arr.length; _i++) {
      var key = _arr[_i];
      ReactiveComp[key] = Comp[key];
    }
  }

  return ReactiveComp;
}

function mapStateToStores(state) {
  // find store properties and map them to their none observable raw value
  // to do not trigger none static this.setState calls
  // from the static getDerivedStateFromProps lifecycle method
  var component = state[COMPONENT];
  return Object.keys(component).map(function (key) {
    return component[key];
  }).filter(isObservable).map(raw);
}

function store(obj) {
  // do not create new versions of the store on every render
  // if it is a local store in a function component
  // create a memoized store at the first call instead
  if (hasHooks && isInsideFunctionComponent) {
    return useMemo(function () {
      return observable(obj);
    }, []);
  }

  return observable(obj);
}
/* eslint camelcase: 0 */
// until the function is finished running


function batch(fn, ctx, args) {
  var result;
  unstable_batchedUpdates(function () {
    return result = fn.apply(ctx, args);
  });
  return result;
} // this creates and returns a batched version of the passed function
// the cache is necessary to always map the same thing to the same function
// which makes sure that addEventListener/removeEventListener pairs don't break


var cache = new Map();

function batchFn(fn) {
  if (typeof fn !== 'function') {
    return fn;
  }

  var batched = cache.get(fn);

  if (!batched) {
    batched = function batched() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return batch(fn, this, args);
    };

    cache.set(fn, batched);
  }

  return batched;
} // batched window.addEventListener(cb) like callbacks


function batchCallbacks(functionWithCallbacks) {
  return function batchedCallbacks() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return functionWithCallbacks.apply(this, args.map(batchFn));
  };
} // batches obj.onevent = fn like calls


function batchMethod(obj, method) {
  var descriptor = Object.getOwnPropertyDescriptor(obj, method);

  if (descriptor) {
    var newDescriptor = Object.assign({}, descriptor, {
      set: function set(value) {
        return descriptor.set.call(this, batchFn(value));
      }
    });
    Object.defineProperty(obj, method, newDescriptor);
  }
} // do a sync batching for the most common task sources
// this should be removed when React's own batching is improved in the future


if (globalObj) {
  // batch timer functions
  globalObj.setTimeout = batchCallbacks(globalObj.setTimeout);
  globalObj.setInterval = batchCallbacks(globalObj.setInterval);

  if (globalObj.requestAnimationFrame) {
    globalObj.requestAnimationFrame = batchCallbacks(globalObj.requestAnimationFrame);
  }

  if (globalObj.requestIdleCallback) {
    globalObj.requestIdleCallback = batchCallbacks(globalObj.requestIdleCallback);
  } // eslint-disable-next-line


  Promise.prototype.then = batchCallbacks(Promise.prototype.then); // eslint-disable-next-line

  Promise.prototype.catch = batchCallbacks(Promise.prototype.catch); // batch addEventListener calls

  if (globalObj.EventTarget) {
    EventTarget.prototype.addEventListener = batchCallbacks(EventTarget.prototype.addEventListener);
    EventTarget.prototype.removeEventListener = batchCallbacks(EventTarget.prototype.removeEventListener);
  } // this batches websocket event handlers


  if (globalObj.WebSocket) {
    var websocketHandlers = ['onopen', 'onmessage', 'onerror', 'onclose'];
    websocketHandlers.forEach(function (method) {
      return batchMethod(globalObj.WebSocket.prototype, method);
    });
  } // HTTP event handlers are usually wrapped by Promises, which is covered above

}

export { view, store, batch };